var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 5,
    y: 7,
    fill: "#f9e3ae",
    rx: 2,
    ry: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#faefde",
    d: "M7,27h8V7H7A2,2,0,0,0,5,9V25A2,2,0,0,0,7,27Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 41,
    y: 41,
    fill: "#72caaf",
    rx: 2,
    ry: 2,
    transform: "rotate(-45 48.998 49.004)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f283a5",
    d: "M49 6A11 11 0 1 0 49 28A11 11 0 1 0 49 6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed7899",
    d: "M49 10A7 7 0 1 0 49 24A7 7 0 1 0 49 10Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#85cbf8",
    d: "M14.13,39.5l-9.27,16A1,1,0,0,0,5.73,57H24.27a1,1,0,0,0,.87-1.5l-9.27-16A1,1,0,0,0,14.13,39.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5dbc9d",
    d: "M58.42,50.41,49.92,58.9a2,2,0,0,1-1.41.58v-21a2,2,0,0,1,1.41.58l8.49,8.49A2,2,0,0,1,58.42,50.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6fc6f0",
    d: "M5.73,57H15V39a1,1,0,0,0-.87.5l-9.26,16A1,1,0,0,0,5.73,57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M24 48v2a1 1 0 0 0 2 0V48a1 1 0 0 0-2 0zM30 47a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V48A1 1 0 0 0 30 47zM35 47a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V48A1 1 0 0 0 35 47zM51.12 38.39a2.89 2.89 0 0 0-1.36-.74l3.94-3.94a1 1 0 0 0-1.41-1.41L50 34.59V28.95a12 12 0 1 0-2 0v5.64l-2.29-2.29a1 1 0 0 0-1.41 1.41l3.94 3.94a2.89 2.89 0 0 0-1.36.74l-8.49 8.48a3 3 0 0 0 0 4.24l8.48 8.49a3 3 0 0 0 4.24 0l8.49-8.49a3 3 0 0 0 0-4.24zM39 17A10 10 0 1 1 49 27 10 10 0 0 1 39 17zM58.19 49.71l-8.49 8.49a1 1 0 0 1-1.41 0l-8.49-8.49a1 1 0 0 1 0-1.41l8.49-8.49a1 1 0 0 1 1.41 0l8.49 8.49a1 1 0 0 1 0 1.41z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M36.71,16.29l-4-4a1,1,0,0,0-1.41,1.41L33.59,16H26V9a3,3,0,0,0-3-3H7A3,3,0,0,0,4,9V25a3,3,0,0,0,3,3H23a3,3,0,0,0,3-3V18h7.59l-2.29,2.29a1,1,0,1,0,1.41,1.41l4-4a1,1,0,0,0,0-1.41ZM24,25a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V9A1,1,0,0,1,7,8H23a1,1,0,0,1,1,1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M14.29,28.29l-4,4a1,1,0,0,0,1.41,1.41L14,31.41V38a1,1,0,0,0,0,.24,2,2,0,0,0-.78.75L4,55a2,2,0,0,0,0,2,2,2,0,0,0,1.73,1H24.27A2,2,0,0,0,26,57a2,2,0,0,0,0-2L16.73,39a2,2,0,0,0-.78-.75A1,1,0,0,0,16,38V31.41l2.29,2.29a1,1,0,0,0,1.41-1.41l-4-4a1,1,0,0,0-1.41,0ZM24.27,56H5.73L15,40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.f5d5fb177fa2e4d545f97fdb435c979f.svg";
export { ForwardRef as ReactComponent };